import { render } from "./Login.vue?vue&type=template&id=1807c802&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=1807c802&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1807c802"

export default script